<template>
  <div class="token-module">
    <ul class="token-list">
      <AddToken :parties="parties" :totalParties="totalParties" />

      <Token v-for="item in parties" :key="item.id" :token="item" />
    </ul>
  </div>
</template>

<script>
  import AddToken from "./AddToken.vue";
  import Token from "./Token.vue";

  export default {
    name: "TokenList",
    components: {
      AddToken,
      Token,
    },
    props: {
      parties: {
        type: Array,
        default: () => [],
      },
      totalParties: {
        type: Number,
      },
    },
  };
</script>

<style scoped lang="scss">
  .token-module {
    width: 100%;
    z-index: 2;
    width: 15vw;
    display: flex;
    align-items: center;

    .token-list {
      height: 100%;
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
      text-align: center;
    }

    li {
      flex-shrink: 0;
    }
  }
</style>
